







































import { Vue, Component } from 'vue-property-decorator';
import Brand from '../../common/model/Brand';
import brandModule from '../../store/modules/brand.module';
import budtenderModule from '../../store/modules/budtender.module';

@Component
export default class BottomFooter extends Vue {
  get brandColor() {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand.primary_color;
  }

  get brandName() {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand.name;
  }

  get brandSecondaryColor() {
    if (!brandModule.brand) {
      return;
    }
    return brandModule.brand.secondary_color;
  }

  get brandSocials() {
    if (!brandModule.brand) {
      return;
    }
    const { brand } = brandModule;
    return [
      { icon: 'mdi-facebook', link: brand.facebook_url },
      { icon: 'mdi-twitter', link: brand.twitter_url },
      { icon: 'mdi-instagram', link: brand.instagram_url },
      { icon: 'mdi-youtube', link: brand.youtube_url },
      { icon: 'mdi-laptop', link: brand.website_url },
    ];
  }
}
